import React, { ChangeEvent, Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import MaskedInput from "react-text-mask";
import styled from "@emotion/styled";

const Root = styled("div")<{ styles?: any }>`
    color: ${(props) => props.theme.palette.grey[100]};
    text-align: left;

    ${(props) => props.styles};
`;

const RadioGroup = styled("div")`
    margin-bottom: 10px;
`;

const SendKeyTo = styled("span")`
    font-size: 14px;
    font-weight: 500;
    margin-right: 13px;
`;

const StyledLabel = styled("label")`
    font-size: 15px;
    font-weight: 700;
    margin-right: 23px;
`;

const StyledMaskedInputBox = styled(MaskedInput)<{ styles?: any }>`
    font-size: 13px;
    min-width: 260px;

    ${(props) => props.styles};
`;

const StyledInputBox = styled("input")<{ styles?: any }>`
    font-size: 13px;
    min-width: 260px;

    ${(props) => props.styles};
`;

type GarageKeyStyles = Partial<{
    root: any;
    inputBox: any;
}>;

export enum GarageKeyType {
    phone = "phone",
    email = "email",
}

export interface GarageKeyProps {
    updateKey: (garageKeyType: GarageKeyType, key: string) => void;
    updateKeyType: (garageKeyType: GarageKeyType) => void;
    label?: string;
    styles?: GarageKeyStyles;
    selectedGarageKey: string;
    garageKeyType: GarageKeyType;
}

class GarageKey extends Component<GarageKeyProps & WithTranslation> {
    public render() {
        const { selectedGarageKey, garageKeyType, label, styles = {}, t } = this.props;

        const isText = garageKeyType === GarageKeyType.phone;
        const isEmail = !isText;

        return (
            <Root styles={styles.root}>
                <RadioGroup>
                    {label && <SendKeyTo>{label}</SendKeyTo>}
                    <StyledLabel htmlFor="keyTypeText">
                        <input
                            type="radio"
                            name="keyType"
                            id="keyTypeText"
                            defaultChecked={isText}
                            onChange={this.setKeyTypeToPhone}
                        />{" "}
                        {t("UserAccount.GarageKey.text")}
                    </StyledLabel>
                    <StyledLabel htmlFor="keyTypeEmail">
                        <input
                            type="radio"
                            value="false"
                            name="keyType"
                            id="keyTypeEmail"
                            defaultChecked={isEmail}
                            onChange={this.setKeyTypeToEmail}
                        />{" "}
                        {t("UserAccount.GarageKey.email")}
                    </StyledLabel>
                </RadioGroup>
                <div>
                    {isText ? (
                        <StyledMaskedInputBox
                            styles={styles.inputBox}
                            type="tel"
                            className="Garage__form--input"
                            placeholder={t("UserAccount.GarageKey.phonePlaceholder")}
                            mask={["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                            guide={false}
                            name="garageKey"
                            onChange={this.updateGarageKey(GarageKeyType.phone)}
                            value={selectedGarageKey}
                        />
                    ) : (
                        <StyledInputBox
                            styles={styles.inputBox}
                            type="email"
                            className="Garage__form--input"
                            placeholder={t("UserAccount.GarageKey.emailPlaceholder")}
                            name="garageKey"
                            onChange={this.updateGarageKey(GarageKeyType.email)}
                            value={selectedGarageKey}
                        />
                    )}
                </div>
            </Root>
        );
    }

    private setKeyTypeToPhone = () => {
        this.setKeyTypeAndResetKey(GarageKeyType.phone);
    };
    private setKeyTypeToEmail = () => {
        this.setKeyTypeAndResetKey(GarageKeyType.email);
    };
    private setKeyTypeAndResetKey = (type: GarageKeyType) => {
        this.props.updateKeyType(type);
        this.props.updateKey(type, "");
    };
    private updateGarageKey = (type: GarageKeyType) => (e: ChangeEvent<HTMLInputElement>) => {
        this.props.updateKey(type, e.target.value);
    };
}

export default withTranslation()(GarageKey);
